import { Component, ViewChild } from "@angular/core";
import { NavController, Platform, Slides } from "ionic-angular";

import { LoginPage } from "../login/login";
import { HomePage } from "../home/home";
import { IdolsListPage } from "../idols-list/idols-list";
import { ConfigService } from "../../services/config.service";

declare var window;

@Component({
  selector: "page-start",
  templateUrl: "start.html",
})
export class StartPage {
  public loginPage = LoginPage;
  public slidesImages: any[];
  @ViewChild("mySlides") slides: Slides;
  finalizar: boolean = false;
  plt: boolean;
  constructor(
    public navCtrl: NavController,
    private configService: ConfigService,
    public platform: Platform
  ) {
    this.plt = this.platform.is("ios");
    this.plt = false;
    if (this.plt) {
      this.slidesImages = [
        {
          image: "assets/imgs/Slide_1a.png",
        },
        {
          image: "assets/imgs/Slide_2_ios.png",
        },
        {
          image: "assets/imgs/Slide_3.png",
        },
      ];
    } else {
      this.slidesImages = [
        {
          image: "assets/imgs/Slide_1a.png",
        },
        {
          image: "assets/imgs/Slide_2.png",
        },
        {
          image: "assets/imgs/Slide_3.png",
        },
      ];
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad StartPage");
  }

  salir() {
    this.configService.setShowSlides("no");
    this.navCtrl.setRoot(IdolsListPage);
  }

  siguiente() {
    if (!this.slides.isEnd()) {
      this.finalizar = false;
    } else {
      this.finalizar = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/start/start.ts